export enum ProjectDetailsTab {
  CLIENT_DATA,
  DEVICES,
  CONCLUDE_PROJECT,
  REPORTS,
  STATUS,
  NOTES,
  DOCUMENTS,
  LOGBOOK,
}

